import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import { BASE_URL, IMAGE_PATHS } from '../../../../constants/paths.constants';
import { universalStyles } from '../../../../app/theme';
import LearningCheckQuestions from '../../../micro/learningCheck/LearningCheckQuestions';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  headerImage: {
    display: 'block',
    width: '100%',
  },
  header: {
    marginTop: 25,
    marginBottom: 0,
  },
  subheader: {
    fontWeight: 'normal',
    fontStyle: 'italic',
  },
  noTopMargin: {
    marginTop: 0,
  },
}));

type InterpretationPage14Props = {
  setNextDisabled: (disabled: boolean) => void;
};

const InterpretationPage14 = ({ setNextDisabled }: InterpretationPage14Props): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.grayBox}>
        {/* Header */}
        <img
          className={classes.headerImage}
          src={`${BASE_URL}${IMAGE_PATHS.STEPS[1].INTERPRETATION_STEP_3.path}`}
          alt={`${IMAGE_PATHS.STEPS[1].INTERPRETATION_STEP_3.alt}`}
        />
        {/* Main Content */}
        <div className={classes.whiteBox}>
          <Typography variant="h2">STEP 3:</Typography>
          <Typography variant="h3">Assess and Evaluate Axumin Uptake in Various Settings (continued)</Typography>
          <Typography variant="h5" className={classes.header}>
            Seminal Vesicles
          </Typography>
          <ul className={classes.list}>
            <li>
              In seminal vesicles, with or without the prostate present, symmetric bilateral uptake similar to blood
              pool is likely physiologic
            </li>
            <li>
              Asymmetric seminal vesicle uptake between blood pool and marrow may increase the suspicion for malignancy;
              consider pelvis MRI for further characterization
            </li>
          </ul>
          <Typography variant="h5" className={classes.header}>
            Please review the images and findings below
          </Typography>
          <Typography variant="h5" className={classes.subheader}>
            See arrows for the location of the lesion and review findings
          </Typography>
          <img
            className={classes.headerImage}
            src={`${BASE_URL}${IMAGE_PATHS.VESTICLES.path}`}
            alt={`${IMAGE_PATHS.VESTICLES.alt}`}
          />
          <Typography variant="body1">
            <b>Findings:</b>
          </Typography>
          <ul className={classNames(classes.list, classes.noTopMargin)}>
            <li>Image of a positive right seminal vesicle lesion</li>
          </ul>
        </div>
      </div>
      <LearningCheckQuestions
        module="axuminInterpretation"
        page={14}
        setNextDisabled={setNextDisabled}
        trainingId={1}
      />
    </>
  );
};

export default InterpretationPage14;
